import { useRestaurantFeaturesQuery, type RestaurantFeaturesQuery, type RestaurantFeaturesQueryVariables } from '~/libs/gql/queries/restaurants/restaurantFeatures.generated';
import type { QueryHookOptions } from '~/lazy_apollo/client';
import { getFeatureFlags, makeIsFeatureActive } from '~/utils/featureFlagsContext';
import { useRestaurantSlugFromUrl } from './useRestaurantSlugFromUrl';

export type RestaurantFeaturesQueryHookOptions = QueryHookOptions<RestaurantFeaturesQuery, RestaurantFeaturesQueryVariables>;

/** read feature information for the current restaurant. by default, information is read from apollo cache. */
export const useRestaurantFeatures = (options: RestaurantFeaturesQueryHookOptions = {}) => {
  const restaurantSlug = useRestaurantSlugFromUrl();
  const { data, ...hookResult } = useRestaurantFeaturesQuery({
    fetchPolicy: 'cache-first',
    skip: !restaurantSlug,
    variables: { restaurantSlug },
    ...options,
  });
  const features = data ? getFeatureFlags(data.restaurantBySlug) : {};
  const isFeatureActive = makeIsFeatureActive(features);
  return { features, isFeatureActive, ...hookResult };
};
